/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_od_ssdna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ssDNA (33)`)
};

const es_od_ssdna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ADNss (33)`)
};

const de_od_ssdna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ssDNA (33)`)
};

const nl_od_ssdna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ssDNA (33)`)
};

const fr_od_ssdna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ADNsb (33)`)
};

const it_od_ssdna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ssDNA (33)`)
};

const pt_br2_od_ssdna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ssDNA (33)`)
};

const pt_od_ssdna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ssADN (33)`)
};

const ja_od_ssdna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ssDNA (33)`)
};

const zh_od_ssdna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ssDNA（33）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const od_ssdna = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.od_ssdna(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("od_ssdna", locale)
	if (locale === "en") return en_od_ssdna(inputs)
	if (locale === "es") return es_od_ssdna(inputs)
	if (locale === "de") return de_od_ssdna(inputs)
	if (locale === "nl") return nl_od_ssdna(inputs)
	if (locale === "fr") return fr_od_ssdna(inputs)
	if (locale === "it") return it_od_ssdna(inputs)
	if (locale === "pt-BR") return pt_br2_od_ssdna(inputs)
	if (locale === "pt") return pt_od_ssdna(inputs)
	if (locale === "ja") return ja_od_ssdna(inputs)
	return zh_od_ssdna(inputs)
};